import * as React from 'react';
import * as Redux from 'react-redux';
import { Grid, TextField, Typography } from '@mui/material';
import * as CONST from '../../../../constants/FieldsConst';
import Box from '@mui/material/Box';
import { saveDeportesAction, setActivoDeportesAction } from '../DeportesAction';
import { validMessage } from '../../../../constants/ValidsFormConst';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import { EstatusField, LoadingWidget } from '../../../../widgets';
import { useNotification } from '../../../../helpers/Notification';

const FormDeportes = ({ isDelete = false }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const deportesStore = Redux.useSelector((state) => state.deportes);

  const activo = isDelete ? null : deportesStore.activo;

  const initData = {
    nombre: '',
    referencia: '',
    link: '',
    desc: '',
    estatus: 1,
  };

  const [data, setData] = React.useState(initData);
  const [dataError, setDataRequired] = React.useState({
    nombre: false,
    referencia: false,
    link: false,
    desc: false,
  });
  const [loadingSave, setLoadingSave] = React.useState(false);

  React.useEffect(() => {
    if (!activo) return;
    let values = {};
    Object.keys(data).map((key) => (values[key] = activo[key]));
    setTimeout(
      () =>
        setData({
          ...values,
          estatus: activo.estatus?.id ?? 1,
        }),
      300,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activo]);

  const _handleSetDataField = (key, value) =>
    setData({ ...data, [key]: value });

  const _validDataForm = () => {
    let r = {};
    let va = [];
    Object.keys(dataError).map((key) => {
      const val = data[key];
      const valid = !val || val === '' || val === 0;
      r[key] = valid;
      return va.push(valid);
    });
    setDataRequired(r);
    return !va.includes(true);
  };

  const _handleSubmit = async () => {
    if (_validDataForm()) {
      setLoadingSave(true);
      const res = await saveDeportesAction(
        { dispatch, notify },
        activo?.id,
        data,
        deportesStore.params,
      );
      if (res) clearData();
      setLoadingSave(false);
    }
  };

  function clearData() {
    setActivoDeportesAction(dispatch, null);
    setData(initData);
  }

  return (
    <Box component="form" sx={{ m: 2 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          <LoadingWidget isLoading={loadingSave} isActivo={activo} />
          <Typography variant="h6">
            {activo ? 'Editar perfil' : 'Crear'}
          </Typography>
        </Grid>

        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            size="small"
            id={CONST.nombre.name}
            required
            label={CONST.nombre.label}
            value={data.nombre}
            onChange={(e) =>
              _handleSetDataField(
                CONST.nombre.name,
                e.target.value.toUpperCase(),
              )
            }
            helperText={dataError.nombre ? validMessage.required : null}
            error={dataError.nombre}
          />
        </Grid>

        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            size="small"
            id={CONST.referencia.name}
            required
            label={CONST.referencia.label}
            value={data.referencia}
            onChange={(e) =>
              _handleSetDataField(CONST.referencia.name, e.target.value)
            }
            helperText={dataError.referencia ? validMessage.required : null}
            error={dataError.referencia}
          />
        </Grid>

        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            size="small"
            id={CONST.link.name}
            required
            label={CONST.link.label}
            value={data.link}
            onChange={(e) =>
              _handleSetDataField(CONST.link.name, e.target.value)
            }
            helperText={dataError.link ? validMessage.required : null}
            error={dataError.link}
          />
        </Grid>

        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            size="small"
            id={CONST.desc.name}
            label={CONST.desc.label}
            value={data.desc}
            multiline
            required
            rows={4}
            onChange={(e) =>
              _handleSetDataField(CONST.desc.name, e.target.value)
            }
            helperText={dataError.desc ? validMessage.required : null}
            error={dataError.desc}
          />
        </Grid>

        <Grid item xs={12} md={12}>
          <EstatusField
            value={data.estatus}
            onChange={(e) =>
              _handleSetDataField(CONST.estatus.name, e.target.value)
            }
            isEstatus
            required
          />
        </Grid>

        <Grid item xs={12} md={12} align="center">
          <BotonComponent
            click={_handleSubmit}
            text={activo ? 'ACTUALIZAR' : 'GUARDAR'}
            disabled={loadingSave}
            green={!activo}
            blue={activo}
            mr={2}
            saveIcon
          />
          {activo && (
            <BotonComponent
              click={clearData}
              text="CANCELAR"
              disabled={loadingSave}
              black
              closeIcon
            />
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default FormDeportes;
